<template>
  <div class="home">
    <!-- 首页头部轮播图 -->
    <div class="homeSec01">
      <div class="swiper-container swiper1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in homeSec01Img" :key="index">
            <div class="homeSec01bg" >
              <el-image
                style="width: 100%; height: 100%"
                :src="item.fileName"
                fit="cover">
              </el-image>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev swiper-button-white swiper_btn"></div>
        <div class="swiper-button-next swiper-button-white swiper_btn"></div>
      </div>
    </div>
    <!-- 新闻部分 -->
    <div class="homeSec02 wrap">
      <!-- 轮播头条新闻广告 -->
      <div class="homeSec02TopAdv">
        <div class="TopAdvHot"><img src="../assets/image/NewhotTit.png" /></div>
        <div class="TopAdvCont">
          <div class="swiper-container swiper2" style="height: 170px;">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in newsTextList" :key="index">
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.artDesc | ellipsis }} <span>[查看详情]</span></p>
                </a>
                <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" target="_blank">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.artDesc | ellipsis }} <span>[查看详情]</span></p>
                </a>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
      <!-- 新闻图+新闻列表 -->
      <div class="homeSec02News">
        <!-- 新闻轮播图 -->
        <div class="homeSec02L">
          <div class="homeSec02Ltit">
            <p class="titR">NEWS</p>
            <p class="titL">新闻动态</p>
          </div>
          <div class="swiper-container swiper3">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in homeSec02Img" :key="index">
                <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                  <div class="homeSec02Lwrap">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.thumb1"
                      fit="cover"
                      class="homeSec02Limg">
                    </el-image>
                    <!-- <img :src="item.img"> -->
                    <div class="homeSec02Ldown">
                      <div class="homeSec02LdownTit">{{ item.title }}</div>
                      <div class="homeSec02LdownCont">{{ item.artDesc }}</div>
                      <div class="homeSec02LdownMore">[查看详情]</div>
                    </div>
                  </div>
                </a>
                <a v-else  target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                  <div class="homeSec02Lwrap">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.thumb1"
                      fit="cover">
                    </el-image>
                    <!-- <img :src="item.img"> -->
                    <div class="homeSec02Ldown">
                      <div class="homeSec02LdownTit">{{ item.title }}</div>
                      <div class="homeSec02LdownCont">{{ item.artDesc }}</div>
                      <div class="homeSec02LdownMore">[查看详情]</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev swiper-button-white swiper_btn"></div>
          <div class="swiper-button-next swiper-button-white swiper_btn"></div>
        </div>
        <!-- 新闻列表 -->
        <div class="homeSec02R">
          <div class="homeSec02Rwrap">
            <div class="homeSec02RMenu clearfloat">
              <div class="menuName">
                <div v-for="(item, index) in nav1" :key="index">
                  <a :href="item.url" target="_blank"
                    :class="{'nav1OnCss':nav1On == index}"
                    @mouseenter="addnav1Css(index)">
                    {{item.title}}
                  </a>
                </div>
              </div>
              <!-- <div class="more">
                <a href="item.url" target="_blank">MORE</a>
              </div> -->
            </div>
            <div class="homeSec02RContent">
              <ul class="menuContent">
                <div v-if="nav1On == 0">
                  <li class="contentList" v-for="(item,index) in companyNewsList" :key="index">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url" class="listTitile">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" class="listTitile">{{item.title}}</a>
                    <div class="listTime">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                  </li>
                </div>
                <div v-if="nav1On == 1">
                  <li class="contentList" v-for="(item,index) in grassrootsList" :key="index">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url" class="listTitile">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" class="listTitile">{{item.title}}</a>
                    <div class="listTime">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                  </li>
                </div>
                <div v-if="nav1On == 2">
                  <li class="contentList" v-for="(item,index) in mediumNewsList" :key="index">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url" class="listTitile">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" class="listTitile">{{item.title}}</a>
                    <div class="listTime">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                  </li>
                </div>
                <div v-if="nav1On == 3">
                  <li class="contentList" v-for="(item,index) in jtNewsList" :key="index">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url" class="listTitile">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" class="listTitile">{{item.title}}</a>
                    <div class="listTime">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                  </li>
                </div>
                <div v-if="nav1On == 4">
                  <li class="contentList" v-for="(item,index) in djpartyList" :key="index">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url" class="listTitile">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" class="listTitile">{{item.title}}</a>
                    <div class="listTime">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div style="clear:both;"></div>
        <div class="homeSec02Pic">
          <img :src="centerBanner">
        </div>
        <!-- 公示公告 -->
        <div class="importNotice">
          <div class="noticeTit">
            <img src="../assets/image/noticeTitlogo.png">
            <p>重要公告</p>
          </div>
          <div class="noticeLink Gd">
            <div class="swiperNotice swiper-container_2" id="swiper4">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in newsNoticeList" :key="index">
                    <a :href="item.url && item.url !== '' ? item.url : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      target="_blank">
                    <!-- <a href=""> -->
                      <span>{{ item.title }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <span style="font-size: 16px;">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                    </a>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业文化 + 宣传视频 -->
    <div class="homeSec03 wrap">
      <!-- 企业文化 -->
      <div class="homeSec03L fl">
        <div class="coculture" :class="'coculture' + (index + 1)" v-for="(item,index) in nav2" :key="index">
          <div class="cocultureWrap fl">
            <a :href="item.url">
              <div class="cocultureImg">
              </div>
              <div class="cocultureTit">
                <p>{{ item.title }}</p>
              </div>
              <div class="cocultureLine">
              </div>
              <div class="cocultureMore">
                <a :href="item.url">查看更多</a>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- 宣传视频 -->
      <div class="homeSec03R fr">
        <div class="homeSec03Rvideo">
          <a href="/list/02320001">
            <video  muted="muted"
              type="video/mp4"
              src="../assets/video/azjsjtxcsp.mp4"
              poster="../assets/video/azjsjtxcsp.png"
              controls loop>
            </video>
            <!-- poster="../assets/video/azjsjtxcsp.jpg" -->
          </a>
        </div>
      </div>
    </div>
    <div style="clear:both;"></div>
    <!-- 精品工程 + 友情链接 -->
    <div class="homeSec04New">
      <div class="homeSec04Tit">
        <p><a href="/list/0232007">精品工程</a></p>
      </div>
      <div class="homeSec04Pic">
        <ul class="homeSec04Wrap" :class="{'onwrapcss' : onwrap !== -1}">
          <li class="homeSec04Item fl" v-for="(item,index) in nbprojects" :key="index"
            :class="{'oncss': onwrap == index}"
            @mouseenter="nbprojectin(index)"
            @mouseleave="nbprojectout()">
              <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">
                <div class="itemTit">
                  <!-- {{ item.tit }} -->
                  {{ item.title }}
                </div>
                <el-image class="itemPic"
                  :src="item.thumb1"
                  fit="cover">
                </el-image >
                <!-- :src="item.pic" -->
                <div class="itemCont">
                  {{ item.artDesc }}
                  <!-- {{ item.cont }} -->
                </div>
              </a>
              <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" target="_blank">
                <div class="itemTit">
                  <!-- {{ item.tit }} -->
                  {{ item.title }}
                </div>
                <el-image class="itemPic"
                  :src="item.thumb1"
                  fit="cover">
                </el-image >
                <!-- :src="item.pic" -->
                <div class="itemCont">
                  {{ item.artDesc }}
                  <!-- {{ item.cont }} -->
                </div>
              </a>
          </li>
        </ul>
      </div>
      <div style="clear:both;"></div>
      <!-- 精品工程手机适配 -->
      <div class="homeSec04Pic768">
        <ul class="homeSec04Pic768wrap">
          <li v-for="(item,index) in nbprojects" :key="index">
            <a href="">
              <div class="itemTit768">
                  <!-- {{ item.tit }} -->
                  {{ item.title }}
                </div>
                <el-image class="itemPic768"
                  style="width: 100%; height: 100%"
                  :src="item.thumb1"
                  fit="cover">
                </el-image >
                <div class="itemCont768"
                  style="position: absolute; bottom: 5%; color: #fff; font-weight: bold;width: 80%; left: 10%; overflow: hidden;
                  text-overflow:ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
                  overflow: hidden; font-size: 15px;"> 
                  {{ item.artDesc }}
                  <!-- {{ item.cont }} -->
                </div>
            </a>
          </li>
        </ul>
      </div>
      <!-- 友情链接 -->
      <div class="friendLink">
        <div class="linkWrap wrap">
          <el-row :gutter="200">
            <!-- 左 -->
            <!-- <el-col :span="8" :sm="12" :md="8" :xs="24">
              <div class="linkL">
                <div class="linkTit">纪检举报中心</div>
                <div class="linkInner">
                  <img src="../assets/image/Broad.png" class="fl">
                  <p class="fr">
                    举报电话：12388<br />
                    网络举报：www.12388.gov.cn<br />
                    举报地址：兰州市七里河区兰天国际广场22楼甘肃省安装建设集团有限公司纪委办公室
                  </p>
                </div>
              </div>
            </el-col> -->
            <!-- 中 -->
            <el-col :span="20" :sm="12" :md="10" :xs="24">
              <div class="linkM">
                <a href="/recruit/02300001/cb0907e9-6933-4be4-93c4-ae53f32e2f76" target="_blank">
                  <div class="linkTit">人才招聘</div>
                  <div class="linkInner">
                    <img src="../assets/image/Broad.png" class="fl">
                    <p class="fr">
                      人才招聘网站：gsazjtrlb@sina.com<br />
                      招聘电话：0931-2340105<br />
                      招聘地址：甘肃省兰州市七里河区兰天国际22楼
                    </p>
                  </div>
                </a>
              </div>
            </el-col>
            <!-- 右轮播 -->
            <el-col :span="12" :sm="24" :md="12" :xs="24">
              <div class="linkR">
                <div class="linkRTit fl">
                    <span>集<br/>团<br/>站<br/>群<br/></span>
                </div>
                <div class="linkRInner fr">
                  <div class="swiper-container" id="swiper5">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(item, index) in newtitleList" :key="index"
                       style="height: 50px;">
                        <a :href="item.httpUrl" target="_blank" class="linkItem">{{ item.name }} </a>
                      </div>
                    </div>
                    <div class="swiper-scrollbar"></div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { WOW } from "wowjs"
// import videojs from 'video.js' 
// import 'videojs-contrib-hls'
// import "@videojs/http-streaming"
import Swiper from 'swiper'
import {
  getTopArtListNew,
  getAdvert,
  // picArticles,
  articles,
  picArticlesRecommend,
  getApplicationList,
  // getArtInfo,
  // getPageInfo,
} from '@/api/common'
export default {
  components: {
    // windowBox,
  },
  name: 'home',
  data(){
    return {
      // 首页头部轮播图
      homeSec01Img: [],
      homeSec01Imgs:[
        { img: require('../assets/image/homeSec01Top1.jpg'), },
        { img: require('../assets/image/homeSec01Top2.jpg'), },
        { img: require('../assets/image/homeSec01Top3.jpg'), },
        { img: require('../assets/image/homeSec01Top4.jpg'), },
        { img: require('../assets/image/homeSec01Top5.jpg'), },
        { img: require('../assets/image/homeSec01Top6.jpg'), }
      ],
      // 头条新闻轮播内容
      newsTextList: [],
      newsTextLists: [
      {
          title: "中央和省级媒体走进甘肃建投活动第一站圆满结束",
          artDesc: "6月21日，中央和省级媒体走进甘肃建投活动第一站圆满结束。",
          url: '/detail/02310004/f7d972f71eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L1.jpg')
        },
        {
          title:"【安全生产月】打好“安全战” 安装公司开展“安全生产月”应急演练活动",
          artDesc:"6月20日，安装公司在永登县污水处理中心提标改造工程开展2023年“安全生产月”应急演练活动，永登县消防救援大队、永登县人民医院联合参演。",
          url: '/detail/02310001/f7d763b71eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L2.jpg')
        },
        {
          title:"安装公司召开“七一”表彰大会",
          artDesc:"6月16日，安装公司在湖南韶山开展红色教育实践活动，召开“七一”表彰大会，表彰2022年度“两优一先”“双优党支部”、优秀通讯员、优秀宣传稿，以及2023年度廉洁文化建设宣传获奖作品。",
          url: '/detail/02310001/f7d758bf1eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L1.jpg')
        },
        {
          title:"安装公司2023年度BIM应用大赛启动会",
          artDesc:"6月13日，公司召开“2023年度安装公司BIM应用大赛”启动会，科技研发中心（BIM）人员、工程公司主任工程师、BIM技术相关人员参加了此次会议。",
          url: '/detail/02310001/f7d753391eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L2.jpg')
        },
        {
          title:"安装公司职工荣获甘肃省技能（BIM）竞赛奖项",
          artDesc:"6月17日、18日，2023年甘肃省百万职工劳动和技能竞赛“BIM技术”省级二类决赛，在甘肃建筑职业技术学院举行。经激烈角逐，安装公司职工康云在比赛中名列15名，荣获二等奖。",
          url: '/detail/02310001/f7d74b501eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L1.jpg')
        }
      ],
      homeSec02Img:[],
      homeSec02Imgs:[
        {
          title: "中央和省级媒体走进甘肃建投活动第一站圆满结束",
          artDesc: "6月21日，中央和省级媒体走进甘肃建投活动第一站圆满结束。",
          url: '/detail/02310004/f7d972f71eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L1.jpg')
        },
        {
          title:"【安全生产月】打好“安全战” 安装公司开展“安全生产月”应急演练活动",
          artDesc:"6月20日，安装公司在永登县污水处理中心提标改造工程开展2023年“安全生产月”应急演练活动，永登县消防救援大队、永登县人民医院联合参演。",
          url: '/detail/02310001/f7d763b71eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L2.jpg')
        },
        {
          title:"安装公司召开“七一”表彰大会",
          artDesc:"6月16日，安装公司在湖南韶山开展红色教育实践活动，召开“七一”表彰大会，表彰2022年度“两优一先”“双优党支部”、优秀通讯员、优秀宣传稿，以及2023年度廉洁文化建设宣传获奖作品。",
          url: '/detail/02310001/f7d758bf1eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L1.jpg')
        },
        {
          title:"安装公司2023年度BIM应用大赛启动会",
          artDesc:"6月13日，公司召开“2023年度安装公司BIM应用大赛”启动会，科技研发中心（BIM）人员、工程公司主任工程师、BIM技术相关人员参加了此次会议。",
          url: '/detail/02310001/f7d753391eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L2.jpg')
        },
        {
          title:"安装公司职工荣获甘肃省技能（BIM）竞赛奖项",
          artDesc:"6月17日、18日，2023年甘肃省百万职工劳动和技能竞赛“BIM技术”省级二类决赛，在甘肃建筑职业技术学院举行。经激烈角逐，安装公司职工康云在比赛中名列15名，荣获二等奖。",
          url: '/detail/02310001/f7d74b501eb811ee8834902e163331ac',
          thumb1: require('../assets/image/Sec02L1.jpg')
        }
      ],
      nav1On: 0,
      nav1:[
        {
          title:"安装要闻",
          url: '/list/02310001'
        },
        {
          title:"基层动态",
          url: '/list/02310002'
        },
        {
          title:"媒体聚焦",
          url: '/list/02310005'
          // url: '/list/01150007'
        },
        {
          title:"建投要闻",
          url: '/list/02310004'
        },
        {
          title:"党的建设",
          url: '/list/02310003'
        }
      ],
      companyNewsList:[],
      jtNewsList:[],
      grassrootsList:[],
      mediumNewsList:[],
      djpartyList:[],
      // 公示公告
      newsNoticeList:[],
      // 企业文化
      nav2:[
        {
          title:"企业文化",
          url: '/list/02320002',
          imgb: require('../assets/image/coculture1.png'),
          imga: require('../assets/image/coculture11.png'),
        },
        {
          title:"职工风采",
          url: '/list/02320004',
          imgb: require('../assets/image/coculture2.png'),
          imga: require('../assets/image/coculture22.png'),
        },
        {
          title:"荣誉奖项",
          url: '/list/02320003',
          imgb: require('../assets/image/coculture3.png'),
          imga: require('../assets/image/coculture33.png'),
        },
        {
          title:"大事记",
          url: '/memorabilia/02320005',
          imgb: require('../assets/image/coculture4.png'),
          imga: require('../assets/image/coculture44.png'),
        }
      ],
      // 精品工程
      nbprojects:[],
      nbproject:[
        {
          tit:"1长庆油田第二采油厂注水站工程",
          cont: "111长庆油田第二采油厂注水站工程，该项目位于甘肃省xxx，项目荣获了xxx、xxx奖项。",
          pic: require('../assets/image/itemPic1.png'),
        },
        {
          tit:"2长庆油田第二采油厂注水站工程",
          cont: "222长庆油田第二采油厂注水站工程，该项目位于甘肃省xxx，项目荣获了xxx、xxx奖项。",
          pic: require('../assets/image/itemPic2.png'),
        },
        {
          tit:"3长庆油田第二采油厂注水站工程",
          cont: "333长庆油田第二采油厂注水站工程，该项目位于甘肃省xxx，项目荣获了xxx、xxx奖项。",
          pic: require('../assets/image/itemPic3.png'),
        },
        {
          tit:"4长庆油田第二采油厂注水站工程",
          cont: "444长庆油田第二采油厂注水站工程，该项目位于甘肃省xxx，项目荣获了xxx、xxx奖项。",
          pic: require('../assets/image/itemPic4.png'),
        },
        {
          tit:"5长庆油田第二采油厂注水站工程",
          cont: "555长庆油田第二采油厂注水站工程，该项目位于甘肃省xxx，项目荣获了xxx、xxx奖项。",
          pic: require('../assets/image/itemPic5.png'),
        }
      ],
      onwrap: -1,
      // 友情链接
      newtitleList: [],
      centerBanner:""
    }
  },
  filters: {
    //超过100位显示 ...
      ellipsis: function (value) {
          if (!value) return ''
          if (value.length > 125) {
            return value.slice(0, 125) + '...'
          }
          return value
        }
  },
  mounted(){
    // var _this = this
    // 首页图片
    setTimeout(() => {
      this.swiper1TopNews()
    }, 500)
    // 新闻广告
    this.bannerNews()
    // 新闻图轮播
    this.sec02L()
    // 新闻列表
    this.companyNews()
    this.jtNews()
    this.grassroots()
    this.mediumNews()
    this.djparty()
    // 公示公告
    this.newsLink()
    // 精品工程
    this.shownbprojects()
    // 友情链接
    this.bannerlink()

  },
  methods: {
    // banner首页头部轮播图
    swiper1TopNews() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 1
      }
      getAdvert(data).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          data.length &&
            data.forEach((line) => {
              if (line.fileName && line.fileName !== '') {
                _this.homeSec01Img.push(line)
              }
            })
            setTimeout(() => {
            new Swiper('.swiper1', {
              loop: true,
              effect: 'fade',
              autoplay: 2000,
              // speed: 1000,
              prevButton:'.swiper-button-prev',
              nextButton:'.swiper-button-next',
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
            })
          }, 500)
        }
      })

      let data2 = {
        applicationUuid: _this.webId,
        advertType: 3
      }
       getAdvert(data2).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.centerBanner = data[0].fileName
        }
       })
    },
    //广告新闻轮播
    bannerNews() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
        
      }
        getTopArtListNew(data).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsTextList = data
          setTimeout(() => {
            new Swiper('.swiper2', {
              loop: true,
              autoplay: 2000,
              speed: 1000,
              crossFade: true,
              pagination : '.swiper-pagination',
              paginationClickable :true,
              observer: true,//修改swiper自己或子元素时，自动初始化swiper
              observeParents: true,//修改swiper的父元素时，自动初始化swiper
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,//用户操作swiper之后重新启动autoplay
            })
          }, 500)
        }
      })
    },
    // 新闻图轮播
    sec02L(){
      var _this = this
      let data = {
        channelUuid: "02310001",
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 5
      }
      picArticlesRecommend(data).then(res =>{
        // console.log(123, res)
        const{code,data} = res
        // code = 1传值正确 && data有数据
        if(code===1 && data ){
          _this.homeSec02Img = data.rows
          // console.log(123, _this.homeSec02Img)
          setTimeout(() => {
            new Swiper('.swiper3', {
              loop: true,
              loopAdditionalSlides : 1,
              // autoplay: true,
              autoplay: 3000,
              speed: 1000,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
              prevButton:'.swiper-button-prev',
              nextButton:'.swiper-button-next',
            })
          }, 500)
        }
      })
    },
    // 新闻列表轮播
    addnav1Css(index) {
      // console.log(666,index);
      this.nav1On = index
    },
    companyNews(){
      var _this = this
      let data = {
        // channelUuid: '01150003',  //集团
        channelUuid: '02310001',  //安装
        // applicationUuid: _this.webId,   //大事记页
        entTApplicationUuid: _this.webId,
        // entTApplicationUuid: _this.webIdGroup,
        pageNum: 1,
        pageSize: 10
      }
      articles(data).then(res =>{
        // console.log(1111, res)
        const{code,data} = res
        if(code===1 && data ){
          _this.companyNewsList = data.rows
          // console.log(1111, _this.companyNewsList)
        }
      })
    },
    grassroots(){
      var _this = this
      let data2 = {
        // channelUuid: "01150003",
        channelUuid: "02310002",
        // entTApplicationUuid: _this.webIdGroup,
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 10
      }
      articles(data2).then(res =>{
        // console.log(3333, res)
        const{code,data} = res
        // code = 1传值正确 && data有数据
        if(code===1 && data ){
          _this.grassrootsList = data.rows
          // console.log(3333, _this.grassrootsList)
        }
      })
    },
    mediumNews(){
      var _this = this
      let data3 = {
        // channelUuid: "01150003",
        channelUuid: "02310005",
        // entTApplicationUuid: _this.webIdGroup,
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 10
      }
      articles(data3).then(res =>{
        // console.log(444, res)
        const{code,data} = res
        // code = 1传值正确 && data有数据
        if(code===1 && data ){
          _this.mediumNewsList = data.rows
          // console.log(444, _this.mediumNewsList)
        }
      })
    },
    jtNews(){
      var _this = this
      let data1 = {
        // channelUuid: "01150003",
        channelUuid: "00190001",
        // entTApplicationUuid: _this.webIdGroup,
        entTApplicationUuid: _this.webIdGroup,
        pageNum: 1,
        pageSize: 10
      }
      articles(data1).then(res =>{
        // console.log(1111, res)
        const{code,data} = res
        // code = 1传值正确 && data有数据
        if(code===1 && data ){
          _this.jtNewsList = data.rows
          // console.log(1222, _this.jtNewsList)
        }
      })
    },
    djparty(){
      var _this = this
      let data3 = {
        // channelUuid: "01150003",
        channelUuid: "02310003",
        // entTApplicationUuid: _this.webIdGroup,
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 10
      }
      articles(data3).then(res =>{
        // console.log(444, res)
        const{code,data} = res
        // code = 1传值正确 && data有数据
        if(code===1 && data ){
          _this.djpartyList = data.rows
          // console.log(444, _this.mediumNewsList)
        }
      })
    },
    // 公示公告
    newsLink(){
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        // channelUuid: '01150003',
        channelUuid: '0233',
        pageNum: 1,
        pageSize: 10
      }
      articles(data).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsNoticeList = data.rows
          if (_this.newsNoticeList.length) {
            setTimeout(() => {
              this.swiper = new Swiper('#swiper4', {
                autoplay: 1,
                loop: true,
                speed: 10000,
                delay: 0,
                slidesPerView: 'auto',
                spaceBetween: 45,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                autoplayDisableOnInteraction: false
              },500)
              // 存放鼠标悬浮时的transform属性（行内属性）
              let nextTransForm = ''
              // 轮播图从暂停位置移动到原本应到的位置所用的时间
              let nextTime = 0
              // 鼠标悬浮暂停轮播
              this.swiper.container[0].onmouseover = function () {
                nextTransForm = document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transform
                // 轮播图原本应移动到的位置
                let nextTransPosition =
                  -1 *
                  parseInt(
                    document
                      .getElementsByClassName('swiper-container_2')[0]
                      .getElementsByClassName('swiper-wrapper')[0]
                      .style.transform.split('translate3d(')[1]
                      .split('px')[0]
                  )
                // 鼠标悬浮时时轮播图位置
                let nowTransPosition =
                  -1 *
                  parseInt(
                    window
                      .getComputedStyle(
                        document
                          .getElementsByClassName('swiper-container_2')[0]
                          .getElementsByClassName('swiper-wrapper')[0],
                        false
                      )['transform'].split('1, ')[2].split(',')[0]
                  )
                // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
                let nowTransForm = window.getComputedStyle(
                  document.getElementsByClassName('swiper-container_2')[0].getElementsByClassName('swiper-wrapper')[0],
                  false
                )['transform']
                // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
                nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
                // 改变行内transform属性
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
                // 不写也没关系
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
                this.swiper.stopAutoplay()
              }
              // 鼠标离开轮播图开始轮播
              this.swiper.container[0].onmouseout = function () {
                // console.log('leave' + nextTransForm)
                // 恢复原样
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
                this.swiper.startAutoplay()
              }
            })
          }
        }
      })
    },
    // 精品工程进入
    nbprojectin(index) {
      // console.log('in',index)
      this.onwrap = index
    },
    // 精品工程出去
    nbprojectout() {
      this.onwrap = -1
      // console.log('out',2)
    },
    // 精品工程
    shownbprojects(){
      var _this = this
      let data = {
        channelUuid: "0232007",
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 5
      }
      picArticlesRecommend(data).then(res =>{
        // console.log(123, res)
        const{code,data} = res
        // code = 1传值正确 && data有数据
        if(code===1 && data ){
          _this.nbprojects = data.rows
          // console.log(123, _this.nbprojects)
        }
      })
    },
    // 友情链接轮播
    bannerlink() {
      var _this = this
      getApplicationList().then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newtitleList = data
          this.$nextTick(() => {
            var mySwiper = new Swiper('#swiper5', {
              direction: 'vertical',
              autoHeight: true,
              speed: 3000,
              autoplay: 1,
              delay: 0,
              loop: true,
              slidesPerView: 6,
              spaceBetween: 0,
              scrollbar: '.swiper-scrollbar',
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false
            })
            mySwiper.container[0].onmouseover = function () {
              mySwiper.stopAutoplay()
            }
            mySwiper.container[0].onmouseout = function () {
              mySwiper.startAutoplay()
            }
          })
        }
      })
    },
    // 查询友情链接站点
    getApplicationList() {
      var _this = this
      getApplicationList().then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newtitleList = data
        }
      })
    },

  }
}
</script>
<style>
.homeSec01 {
  height: auto;
  width: 100%;
  margin-bottom: 40px;
}
.homeSec01 .swiper-container,
.homeSec01 .swipertop1 .swiper-wrapper,
.homeSec01 .swipertop1 .swiper-slide
{
  width: 100% ;
  height: 100%;
}
.homeSec01bg {
  width: 100% ;
  height: 540px;
}
.homeSec02 {
  height: auto;
}
.homeSec02TopAdv {
  /* height: 134px; */
  height: auto;
  /* background-color: aqua; */
  width: 100%;
  position: relative;
  overflow: hidden;
}
.TopAdvHot {
  height: 100%;
  /* background-color: rgb(0, 89, 255); */
  position: absolute;
}
.TopAdvHot img {
  height: 160%;
}
.TopAdvCont {
  width: 93%;
  float: right;
}
.TopAdvCont .swiper-container,
.TopAdvCont .swipertop1 .swiper-wrapper,
.TopAdvCont .swipertop1 .swiper-slide
{
  width: 100% ;
  height: 100%;
}
.TopAdvCont a h2{
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 34px;
  height: 42px;
  line-height: 42px;
  margin: auto;
  text-align: center;
  font-weight: 700;
  color: #000000;
  /* background-color: rgb(242, 0, 255); */
}
.TopAdvCont a h2:hover {
  color: #0170C1;
}
.TopAdvCont a p{
  width: 100%;
  height: 84px;
  font-size: 18px;
  line-height: 28px;
  margin: 18px 0;
  color: rgb(113, 113, 113);
  /* background-color: rgb(0, 255, 30); */
  text-indent: 2em;
  overflow: hidden;
  /* overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
}
.swiper2 .swiper-pagination-bullet-active,.swiper-pagination-bullet {
  width:50px;
  height: 5px;
  background-color: rgb(0, 0, 0);
  /* position: relative; */
  border-radius: 0px;
}
.swiper2 .swiper-pagination-bullet-active{
  background-color: #ff0000;
}
/* sec02新闻部分 */
.homeSec02News{
  margin-top: 10px;
}
.homeSec02NewsPic {
  width: 100%;
  height: auto;
}
.homeSec02L{
  width: 52%;
  height: 540px;
  /* background-color: pink; */
  float: left;
  position: relative;
}
.homeSec02Ltit {
  position: absolute;
  width: 90%;
  height: 9%;
  right: 0;
  font-size: 24px;
  font-weight: bold;
  /* border-bottom: 5px solid #767676; */
  background: url(../assets/image/newsLine.jpg) bottom repeat-x;
}
.homeSec02Ltit p{
  float: right;
  font-size: 24px;
  margin-top: 5px;
}
.homeSec02Ltit .titL {
  width: 20%;
  color: #0170C1;
}
.homeSec02Ltit .titR {
  width: 13%;
  color: #000000;
}
.swiper3{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 86%;
  /* background-color: #EAA334; */
}
.homeSec02Lwrap{
  width: 100%;
  height: 100%;
  position: absolute;
}
.homeSec02Lwrap img{
  width: 100%;
  height: 100%;
  transition: all 0.5s linear;
}
.swiper3:hover .homeSec02Lwrap img{
  transform: scale(1.2);
}
.homeSec02Ldown{
  width: 100%;
  height: 15%;
  bottom: 0;
  position: absolute;
  background-color: rgb(0, 0, 0);
  overflow: hidden;
  opacity: 0.7;
}
.homeSec02LdownTit{
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: auto;
  height: 35px;
  font-size: 16px;
  line-height: 35px;
  /* background-color: rgb(255, 255, 0); */
  text-align: center;
  color: white;
}
.homeSec02LdownCont{
  float: left;
  width: 83%;
  height: 25px;
  line-height: 25px;
  color: white;
  font-size: 14px;
  padding-left: 8px;
  /* background-color: rgb(0, 255, 0); */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.homeSec02LdownMore{
  float: right;
  width: 15%;
  line-height: 25px;
  color: #0170C1;
}
.homeSec02L .swiper-button-next,
.homeSec02L .swiper-button-prev {
  margin: 0 10px;
  width:45px;
  top: 285px;
  height: 30px;
}
.homeSec02R{
  /* width: 680px; */
  width: 45%;
  height: 540px;
  /* background-color: rgb(189, 182, 250); */
  float: right;
}
.homeSec02Rwrap{
  width: 100%;
  height: 100%;
  /* background-color: rgb(168, 159, 248); */
  margin-top: 10px;
  overflow: hidden;
}
.homeSec02RMenu{
  height: 42px;
  overflow: hidden;
  position: relative;
}
.homeSec02RMenu .menuName a{
  text-decoration: none;
  float: left;
  width: 19%;
  margin-right: 1%;
  background-color: rgb(223, 223, 223);
  text-align: center;
  line-height: 38px;
  color: black;
  font-size: 16px;
  font-weight:bold;
  transition: all 0.3s ease-out;
}
.homeSec02RMenu .menuName a:hover {
  background-color: rgb(0, 98, 177);
  color: #ffffff;
}
.homeSec02RContent{
  margin-top: 10px;
}
.menuContent li{
  overflow: hidden;
}
.contentList .listTitile{
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: all 0.3s ease-out;
  width: 75%;
}
.menuContent .contentList:hover .listTitile {
  margin-top: -3px;
  color: #0170C1;
}
.contentList .listTime{
  float: right;
  margin-right: 15px;
  font-size: 17px;
  line-height: 48px;
}
.contentList a{
  font-size: 17px;
  line-height: 48px;
  height: 48px;
}
.menuContent{
  position: relative;
}
.homeSec02Pic {
  width: 100%;
  margin-top: 40px;
}
.homeSec02Pic img{
  width: 100%;
}
/* 公示公告 */
.importNotice{
  height: 40px;
  width: 100%;
  background-color: #F1F1F1;
  margin: 30px auto;
  /* position: relative; */
}
.noticeTit{
  height: 100%;
  width:13%;
  /* background-color: yellow; */
  line-height: 40px;
  color: #FF0000;
  text-align: center;
  font-size: 16px;
  font-weight:bold;
  float: left;
}
.noticeTit img{
  width: 25px;
  height: 25px;
  margin: 8px 10px 0 10px;
  float: left;
}
.noticeTit p{
  float: left;
}
.noticeLink{
  height: 100%;
  width: 86%;
  float: left;
  font-weight: bold;
  line-height: 40px;
  /* background-color: #EAA334; */
  overflow: hidden;
}
.noticeLink a:hover{
  color: #337ab7;
}
#swiper4 .swiper-wrapper {
  transition-timing-function: linear; 
}
#swiper4 .swiper-slide {
  width: auto;
}
/* homeSec03 */
.homeSec03 {
  height: 562px;
}
.homeSec03L {
  /* height: 502px; */
  width: 40%;
  /* background-color: rgb(255, 201, 201); */
}
.coculture {
  width: 100% ;
}
.cocultureWrap {
  background-color: rgb(243, 242, 242);
  width: 44%;
  margin: 3%;
  text-align: center;
  transition: all 0.5s ease-out;
  height: 230px;
}
.cocultureWrap:hover {
  background-color: rgb(2, 99, 180);
}
.cocultureImg {
  /* background-color: rgb(121, 255, 143); */
  position: relative;
  top: 20px;
  /* margin-top: 20px; */
  /* width: 18%;
  height: 28%; */
  width: 50px;
  height: 50px;
  margin: 0 auto;
  background-size: 68%;
  background-position: bottom center;
  background-repeat: no-repeat;
  transition: all 0.4s ease-out;
  
}
.coculture1 .cocultureImg {
  background-image: url(../assets/image/coculture1.png);
}
.coculture1:hover .cocultureImg {
  background-image: url(../assets/image/coculture11.png);
  transform: rotateZ(360deg);
}
.coculture2 .cocultureImg {
  background-image: url(../assets/image/coculture2.png);
}
.coculture2:hover .cocultureImg {
  background-image: url(../assets/image/coculture22.png);
  transform: rotateZ(360deg);
  
}
.coculture3 .cocultureImg {
  background-image: url(../assets/image/coculture3.png);
}
.coculture3:hover .cocultureImg {
  background-image: url(../assets/image/coculture33.png);
  transform: rotateZ(360deg);
}
.coculture4 .cocultureImg {
  background-image: url(../assets/image/coculture4.png);
}
.coculture4:hover .cocultureImg {
  background-image: url(../assets/image/coculture44.png);
  transform: rotateZ(360deg);
}
.cocultureTit p{
  line-height: 30px;
  font-size: 17px;
  transition: all 0.5s ease-out;
  margin: 30px 0 25px 0;
  position: relative;
  top: 0;
  /* background-color: rgb(0, 145, 24); */
}
.cocultureWrap:hover .cocultureTit p{
  color: #ffffff;
  top: 5px;
  /* margin-top: 3px; */
}
.cocultureLine {
  width: 80%;
  height: 2px;
  margin: 0 auto;
  transition: all 0.5s ease-out;
  background-color: rgb(2, 99, 180);
}
.cocultureWrap:hover .cocultureLine {
  background-color: rgb(255, 255, 255);
}
.cocultureMore {
  /* background-color: rgb(209, 234, 255); */
  border: 1px solid rgb(2, 99, 180);
  border-radius: 5px;
  margin: 20px auto 0;
  width: 60%;
  height: 40px;
  transition: all 0.5s ease-out;
  line-height: 40px;
}
.cocultureMore a {
  transition: all 0.5s ease-out;
}
.cocultureWrap:hover .cocultureMore a{
  color: #ffffff;
}
.cocultureWrap:hover .cocultureMore{
  border: 1px solid rgb(255, 255, 255);
}
.homeSec03R {
  width: 59%;
  height: 522px;
  background-color: rgb(60, 0, 255);
}
.homeSec03Rvideo {
  height: 100%;
  width: 100%;
}
video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
/* homeSec04 */
/* 精品工程 */
.homeSec04Tit p {
  line-height: 80px;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 20px;
}
.homeSec04Tit p a {
  color: rgb(2, 99, 180);
}
.homeSec04Pic {
  width: 100%;
  overflow: hidden;
  height: 400px;
  /* background-color: #ffbebe; */
}
.homeSec04Wrap {
  /* height: 260px; */
  height: 100%;
  /* background-color: #d4ffbe; */
  overflow: hidden;
}
.homeSec04Item {
  height: 65%;
  background-color: rgb(2, 99, 180);
  position: relative;
  text-align: center;
  top: 50%;
  transform: translate(0%, -50%);
  width: 20%;
  transition: all 0.3s linear;
}
.homeSec04Item:first-child {
  margin-left: 0;
}
.homeSec04Item .itemTit {
  /* background-color: #000000; */
  visibility: hidden;
  width: 70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  margin: 0 auto;
  position: absolute;
  left: 15%;
  top: 6%;
  /* top: 10px; */
}
.homeSec04Item .itemPic {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
}
.homeSec04Item .itemCont {
  visibility: hidden;
  position: absolute;
  /* background-color: #ff0000; */
  width: 86%;
  height: 40px;
  line-height: 20px;
  left: 7%;
  bottom: 4%;
  color: #ffffff;
  font-size: 15px;
  text-indent: 2em;
  font-weight: bold;
  overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: all 0;
}
.homeSec04Wrap.onwrapcss .homeSec04Item{
  width: 17.5%;
}
.homeSec04Wrap.onwrapcss .homeSec04Item.oncss {
  width: 30%;
  height: 100%;
}
.homeSec04Wrap.onwrapcss .homeSec04Item.oncss .itemTit,
.homeSec04Wrap.onwrapcss .homeSec04Item.oncss .itemCont {
  visibility: visible;
}
.homeSec04Wrap.onwrapcss .homeSec04Item.oncss .itemPic {
  width: 90%;
  height: 68%;
  /* margin: 9% auto 0; */
  top: 15%;
}
/* 精品工程手机适配 */
.homeSec04Pic768 {
  display: none;
  height: auto;
  width: 100%;
}
.homeSec04Pic768wrap {
  height: 100%;
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.homeSec04Pic768wrap li a {
  display: block;
  height: 300px;
  width: 100%;
  text-align: center;
  margin: 5px auto;
  position: relative;
}
.homeSec04Pic768wrap li a .itemTit768 {
  width: 80%;
  left: 10%;
  top: 5%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  z-index: 3;
}
.homeSec84Pic768wrap li a .itemCont768 {
  position: absolute;
  background-color: #a6ff00;
  color: #ffffff;
  top: 0;
  /* width: 86%;
  height: 40px;
  line-height: 20px;
  color: #ffffff;
  font-size: 15px;
  text-indent: 2em;
  font-weight: bold;
  overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
  z-index: 4;
}

/* 友情链接 */
.friendLink {
  height: auto;
  width: 100%;
  margin: 30px auto;
  background: url(../assets/image/Links.png);
  background-repeat: no-repeat;
  overflow: hidden;
  background-size: 100% 100%;
}
.linkWrap {
  height: auto;
  margin: 40px auto;
}
.linkL, .linkM {
  background-color: rgb(255, 255, 255, 0.5);
  height: 180px;
  margin-top: 30px;
}
.linkR {
  background-color: rgb(255, 255, 255, 0.5);
  height: 240px;
}
.linkTit {
  text-align: center;
  font-size: 22px;
  height: 30%;
  line-height: 54px;
  letter-spacing: 5px;
  font-weight: bold;
  color: rgb(2, 99, 180);
  /* background-color: red; */
}
.linkRTit {
  text-align: center;
  width: 10%;
  height: 160px;
  position: relative;
  top: 16.6%;
  font-size: 18px;
  line-height: 40px;
  font-weight: bold;
  color: rgb(2, 99, 180);
  /* background-color: red; */
}
.linkInner {
  /* background-color: rgba(255, 0, 0, 0.5); */
  width: 100%;
  height: 70%;
}
.linkInner img {
  height: 100%;
  width: 18%;
  /* background-color: rgba(0, 255, 145, 0.5); */
}
.linkInner p {
  /* height: 100%; */
  width: 80%;
  /* background-color: rgba(255, 0, 251, 0.5); */
  color: rgb(2, 99, 180);
  font-size: 15px;
  line-height: 30px;
}
.linkRInner {
  /* background-color: rgba(255, 0, 0, 0.5); */
  width: 87%;
  height: 100%;
  border-left: 1px solid rgb(2, 99, 180);
}
.linkRInner #swiper5 {
  width: 100%;
  height: 240px;
}
.linkRInner #swiper5 .swiper-slide {
  width: 100%;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
}
.linkRInner #swiper5 .swiper-slide .linkItem {
  height: 40px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 40px;
  margin-left: 7%;
}

@media (max-width: 1366px) {
  .homeSec01bg {
    height: 440px;
  }
  .swiper1 .swiper-button-next,
  .swiper1 .swiper-button-prev {
    top: 180px;
  }
  .homeSec02Ltit .titL {
    width: 26%;
  }
  .homeSec02Ltit .titR {
    width: 16%;
  }
  .linkInner {
    position: relative;
  }
  .linkInner img {
    position: absolute;
  }
  .linkInner p {
    position: relative;
    width: 95%;
  }
}
@media (max-width: 992px) {
  .homeSec01bg {
    height: 320px;
  }
  .swiper1 .swiper-button-next,
  .swiper1 .swiper-button-prev {
    top: 125px;
  }
  .homeSec02Ltit .titL {
    width: 32%;
  }
  .homeSec02Ltit .titR {
    width: 20%;
  }
  .noticeTit {
    width: 18%;
  }
  .noticeLink {
    width: 80%;
  }
  .linkL, .linkM {
    margin-top: 0px;
  }
  .linkR {
    margin-top: 30px;
  }
}
@media (max-width: 768px) {
  .homeSec01bg {
    height: 150px;
  }
  .swiper1 .swiper-button-next,
  .swiper1 .swiper-button-prev {
    top: 60px;
    width: 30px;
    height: 30px;
    margin: 0 10px;
  }
  .TopAdvHot {
    display: none;
  }
  .TopAdvCont {
    width: 98%;
  }
  .TopAdvCont a h2 {
    font-size: 16px;
  }
  .TopAdvCont a p {
    font-size: 14px;
  }
  .homeSec02L,
  .homeSec02R {
    width: 100%;
  }
  .homeSec02L {
    height: 300px;
  }
  .homeSec02Ltit {
    height: 13%;
  }
  .homeSec02Ltit .titL {
    width: 45%;
  }
  .homeSec02Ltit .titR {
    width: 25%;
  }
  .homeSec02Ldown {
    height: 25%;
  }
  .homeSec02L .swiper-button-next,
  .homeSec02L .swiper-button-prev {
    top: 160px;
    height: 30px;
  }
  .noticeTit {
    width: 15%;
  }
  .noticeTit p{
    display: none;
  }
  .homeSec03L,
  .homeSec03R {
    width: 100%;
  }
  .homeSec03R {
    height: 300px;
  }
  .homeSec04Pic {
    display: none;
  }
  .homeSec04Pic768 {
    display: block;
  }
  .linkM {
    margin-top: 30px;
  }
  .linkInner p {
    width: 80%;
  }
}
</style>